module.exports = __webpack_public_path__ + "img/aktiviti-lawatan.724ed49b.jpeg";